import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()
export class LandingService {

    constructor(
        private http: HttpClient
    ) { }

    logout() {
        return this.http.post(environment.serverUrl + '/user/logout', {});
    }

    meService() {
        return this.http.get(environment.serverUrl + '/me-new');
    }
}



// WEBPACK FOOTER //
// ./src/app/landing/landing.service.ts